import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { Box, Stack } from "@mui/material";
import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { FormHelper } from "../../../helpers/formHelper";
import { UserService } from '../../../services/userService';
import { CommunicationPreferenceSchema } from "../../validations/schema";
import { Section } from '../common/section';
import { SectionWithHeading } from "../common/sectionWithHeading";
import { ButtonWrapper } from '../formUtilities/useButton';
import SelectWrapper from "../formUtilities/useSelect";
import { TextWrapper } from '../formUtilities/useTextWrapper';

export const CommunicationPreference = () => {
  const userService = new UserService();
  const { t } = useTranslation();
  const { investorCollections } = useSelector(
    (state) => state.investorCollectionReducer
  );
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const languages = investorCollections?.languages || [];
  // const communicationChannels = investorCollections?.communicationChannels || [];
  // const communicationContents = investorCollections?.communicationContents || [];

  const form = useFormik({
    initialValues: {
      communicationChannelIds: [],
      preferredLanguage: "",
      communicationContentIds: []
    },
    onSubmit: () => {
      onSubmit();
    },
    validationSchema: CommunicationPreferenceSchema,
    ...FormHelper.formikProps()
  });

  useEffect(() => {
    getCommunicationPreference();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCommunicationPreference = () => {
    setLoading(true);
    userService.getCommunicationPreference().then(resp => {
      form.setValues(resp.data?.data);
      setLoading(false);
    }).catch(err => { setLoading(false); });
  };

  const onSubmit = () => {
    setLoadingSave(true);
    userService.submitCommunicationPreference(form.values).then(resp => {
      setLoadingSave(false);
      getCommunicationPreference();
    }).catch(err => { setLoadingSave(false); });
  };

  return <SectionWithHeading
    loading={loading}
    heading={
      <Box className="flex items-center">
        <SettingsSuggestIcon
          className="!text-[26px]"
          color="primary"></SettingsSuggestIcon>
        <span className="mx-2">{t('communicationPreference')}</span>
      </Box>
    }
    children={
      <FormikProvider value={form}>
        <Box className='flex justify-center'>
          <Section classList='!w-full !p-0' isShadow={false}
            children={
              <Stack
                className="text-start"
                gap={2}>
                <TextWrapper
                  classList="!sub-title-text"
                  text={t('communicationPreferenceInfo')}></TextWrapper>
                {/* <hr className="border-color-primary"></hr> */}
                <FormikProvider value={form}>
                  <Box className='grid grid-cols-1 md:grid-cols-2 gap-4 mt-3'>
                    <SelectWrapper
                      items={languages}
                      label="preferedLanguage"
                      name="preferredLanguage"
                      key={'preferredLanguage'}></SelectWrapper>

                    {/* <SelectWrapper
                      items={communicationChannels}
                      multiSelect
                      label="chooseCommunicationChannel"
                      name="communicationContentIds"
                      key={'communicationContentIds'}>
                    </SelectWrapper>

                    <SelectWrapper
                      items={communicationContents}
                      multiSelect
                      label="selectContent"
                      name="communicationChannelIds"
                      key={'communicationChannelIds'}></SelectWrapper> */}
                  </Box>
                  <Box className='flex justify-center mt-3'>
                    <ButtonWrapper
                      largeBtn
                      loading={loading || loadingSave}
                      onClick={() => {
                        FormHelper.validateForm(form);
                      }}
                      label={t('save')}></ButtonWrapper>
                  </Box>
                </FormikProvider>
              </Stack>
            }></Section>
        </Box>
      </FormikProvider>
    }></SectionWithHeading>;
};